import {
  ONBOARDING_DETAILS_SAVE_REQUEST,
  RESET_BLOCK_ONBOARDING,
  RESET_FLAGS_ONBOARDING,
  SET_STEPS_DATA,
  SIDEBAR_LIST,
} from "../reducers/OnboardingReducer";

export const setStepsData = (payload) => ({ type: SET_STEPS_DATA, payload });

export const onboardingDataSaveAPI = (payload) => ({
  type: ONBOARDING_DETAILS_SAVE_REQUEST,
  payload,
});
export const sideBarList = (payload) => ({
  type: SIDEBAR_LIST,
  payload,
});

export const resetBlockOnboarding = (payload) => ({
  type: RESET_BLOCK_ONBOARDING,
  payload,
});

export const resetFlagsOnboarding = (payload) => ({
  type: RESET_FLAGS_ONBOARDING,
  payload,
});
